import {z} from "zod"

export const color = z.object({r: z.number(), g: z.number(), b: z.number(), a: z.number().optional()})
export type Color = z.infer<typeof color>
